<section class="users-edit">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- Nav-tabs -->
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="1"
              class="nav-tabs justify-content-left"
            >
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <!-- Account content starts -->
                  <div class="mt-2" id="account">
                    <!-- Media object starts -->
                    <!-- <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-2.png" alt="user edit avatar"
                          class="users-avatar-shadow avatar mr-3 rounded-circle" height="64" width="64">
                        <div class="media-body">
                          <h4>Avatar</h4>
                          <div class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2">
                            <button class="btn btn-sm btn-primary mb-1 mb-sm-0">Change</button>
                            <button class="btn btn-sm bg-light-secondary ml-sm-2">Reset</button>
                          </div>
                        </div>
                      </div>  -->
                    <div class="media">
                      <img
                        *ngIf="imgUrl"
                        [src]="imgUrl"
                        alt="user edit avatar"
                        class="users-avatar-shadow avatar mr-3 rounded-circle"
                        height="64"
                        width="64"
                      />
                      <img
                        *ngIf="!imgUrl && userData?.image"
                        [src]="imageUrl + userData?.image"
                        alt="user edit avatar"
                        class="users-avatar-shadow avatar mr-3 rounded-circle"
                        height="64"
                        width="64"
                      />
                      <div *ngIf="!imgUrl && !userData?.image" [class.initial-alpha]="!userData?.image" class="users-avatar-shadow rounded mr-1 ml-0" >
                        <div class="avatar-content">{{ userData?.name | shortName }}</div>
                      </div>
                      <!-- <img *ngIf="imgUrl" [src]="imgUrl" alt="user edit avatar"
                      class="users-avatar-shadow rounded mr-3" height="64" width="64">
                      <img  *ngIf="!imgUrl && userData?.image " [src]="imageUrl + userData?.image" alt="user edit avatar"
                      class="users-avatar-shadow rounded mr-3" height="64" width="64">
                      <div *ngIf="!imgUrl && !userData?.image" [class.initial-alpha]="!userData?.image" class="users-avatar-shadow rounded mr-1 ml-0" >
                        <div class="avatar-content">{{ userData?.name | shortName }}</div>
                      </div> -->
                      <div class="media-body">
                        <h4>{{ userData?.name }}</h4>
                        <div
                          class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2"
                        >
                          <label
                            class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset"
                            >Change
                            <input
                              type="file"
                              #fileInput
                              class="form-control"
                              (change)="onSelectFile($event)"
                              hidden
                            />
                          </label>
                          <button
                            class="btn btn-sm bg-light-secondary ml-sm-2"
                            (click)="resetImage()"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Media object ends -->

                    <!-- Account form starts -->
                    <form>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <fieldset class="form-group">
                            <label for="name">Name</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="userData.name"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter name"
                              readonly
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="Email">Email</label>
                            <input
                              type="email"
                              class="form-control"
                              [(ngModel)]="userData.email"
                              [ngModelOptions]="{ standalone: true }"
                              id="Email"
                              placeholder="Enter email"
                              readonly
                            />
                          </fieldset>
                          <fieldset
                            class="form-group"
                            *ngIf="userData?.roles == 'student'"
                          >
                            <label for="gender">Sex</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="userData.gender"
                              [ngModelOptions]="{ standalone: true }"
                              id="gender"
                              readonly
                            />
                          </fieldset>

                          <fieldset
                            class="form-group"
                            *ngIf="userData?.roles == 'student'"
                          >
                            <label for="course">College</label>
                            <input
                              type="text"
                              [(ngModel)]="userData.college"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="college"
                              placeholder="Enter college"
                            />
                          </fieldset>
                          <fieldset class="form-group" >
                            <label for="sessionStarted">Session Started</label>
                            <input type="text"  [(ngModel)]="userData.sessionStarted" [ngModelOptions]="{standalone: true}"  class="form-control" id="sessionStarted"  placeholder="Enter session started">
                          </fieldset>



                          

                          <!-- <fieldset class="form-group" >
                                    <label for="sessionStarted">Session Started</label>
                                    <input type="text"  [(ngModel)]="userData.sessionStarted" [ngModelOptions]="{standalone: true}"  class="form-control" id="sessionStarted"  placeholder="Enter session started">
                                  </fieldset> -->
                          <!-- <fieldset class="form-group"  >
                                    <label for="position">position</label>
                                    <input type="text" [(ngModel)]="userData.position" [ngModelOptions]="{standalone: true}" class="form-control" id="position"  placeholder="enter position">
                                  </fieldset>                          
                                  <fieldset class="form-group" >
                                    <label for="salary">salary</label>
                                    <input type="text"  [(ngModel)]="userData.salary" [ngModelOptions]="{standalone: true}" class="form-control" id="salary"  placeholder="enter salary">
                                  </fieldset> -->
                          <!-- <fieldset class="form-group">
                                    <label for="password">password</label>
                                    <input type="text" class="form-control"   [(ngModel)]="userData.password" [ngModelOptions]="{standalone: true}" id="name"  placeholder="enter password">
                                  </fieldset>                    -->
                        </div>

                        <div class="col-12 col-md-6">
                          <!-- <fieldset class="form-group">
                            <label for="name">Course</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="userData.course.courseName"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter Course"
                            />
                          </fieldset> -->

                          <fieldset
                            class="form-group"
                            *ngIf="userData?.role?.type == 'student'"
                          >
                            <label for="dob">Date Of Birth</label>
                            <input
                              type="date"
                              class="form-control"
                              [(ngModel)]="userData.dob"
                              [ngModelOptions]="{ standalone: true }"
                              id="dob" 
                              readonly
                            />
                          </fieldset>

                          <fieldset
                            class="form-group"
                            *ngIf="userData?.role?.type == 'student'"
                          >
                            <ng-select
                              [items]="courses"
                              bindLabel="courseName"
                              bindValue="_id"
                              [multiple]="true"
                              [closeOnSelect]="false"
                              placeholder="Select course"
                              [(ngModel)]="selectedValue"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCourseId($event)"
                              [disabled]="true"
                              >
                            </ng-select>
                           
                          </fieldset>
                          <fieldset class="form-group">
                            <ng-select 
                              [items]="batchList"
                              bindLabel="name"
                              bindValue="_id"
                              [multiple]="true"
                              [closeOnSelect]="true"
                              placeholder="Select Batch"
                              [(ngModel)]="selectedBatch"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getBatchId($event)"
                              [disabled]="true"
                              >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="college">Phone Number</label>
                            <input
                              type="text" 
                              placeholder="e.g. (555) 555 5555" mask="(000) 000-0000" minlength="10"
                              [(ngModel)]="userData.phoneNumber"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="phoneNumber"
                              placeholder="Enter phoneNumber" />
                          </fieldset>

                          <!-- <fieldset class="form-group">
                            <label for="categary">Image</label>
                            <img
                              class="ml-2"
                              *ngIf="!imgUrl"
                              [src]="imageUrl + userData.image"
                              alt=""
                              width="100px"
                              height="100px"
                              style="border-radius: 10px"
                            />
                            <img
                              class="ml-2"
                              *ngIf="imgUrl"
                              [src]="imgUrl"
                              alt=""
                              width="100px"
                              height="100px"
                              style="border-radius: 10px"
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="categary">Change Banner</label>
                            <input
                              type="file"
                              class="form-control"
                              (change)="onSelectFile($event)"
                            />
                          </fieldset> -->

                          <!-- <fieldset class="form-group" >
                                      <label for="trainingPeriod">Training Period</label>
                                      <input type="text" [(ngModel)]="userData.trainingPeriod" [ngModelOptions]="{standalone: true}" class="form-control" id="trainingPeriod"  placeholder="Enter training period">
                                    </fieldset>
                                    <fieldset class="form-group" >
                                      <label for="placementStatus">Placement Status</label>
                                      <input type="text" [(ngModel)]="userData.placementStatus" [ngModelOptions]="{standalone: true}" class="form-control" id="placementStatus"  placeholder="Enter placement status">
                                    </fieldset> -->
                        </div>
                        <div
                          class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                        >
                          <button
                            type="submit"
                            class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                            (click)="userUpdate()"
                          >
                            Save Changes
                          </button>
                          <button
                            type="reset"
                            class="btn btn-secondary"
                            (click)="back()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- Account form ends -->
                  </div>
                  <!-- Account content ends -->
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
